<template>
  <div>
    <el-button type="primary" @click="openWindow">选择资产</el-button>
    <el-dialog append-to-body title="选择资产" :visible.sync="deviceVisible" :before-close="handleClose"
    :close-on-click-modal="false"
      :close-on-press-escape="false" width="45%">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="所属单位">
          <el-input v-model="zxdw" :disabled="true" placeholder="请选择单位"></el-input>
          
          <!-- <el-cascader v-model="formInline.companyCode" :disabled="isSelect" style="width:140px" :options="options"
            :props="props1" clearable :show-all-levels="false" filterable placeholder="请选择单位"></el-cascader> -->
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formInline.statue" style="width:150px" placeholder="请选择状态" clearable>
            <el-option v-for="item in deviceStatuData" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模糊搜索">
          <el-input v-model="formInline.content" placeholder="搜索内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="findAll">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table ref="deviceTable" id="deviceTable" :row-key="getRowKeys" :data="tableData" tooltip-effect="dark"
        style="width: 100%;" height="300" size="mini" @selection-change="changeCheckBoxValue">
        <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
        <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="zcbh" label="资产编号" width="120">
        </el-table-column>
        <el-table-column prop="zcmc" label="资产名称" width="120">
        </el-table-column>
        <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="sbzt" label="设备状态" show-overflow-tooltip>
          <template slot-scope="scope" show-overflow-tooltip>
            <span v-if="scope.row.sbzt == '1'" style="color:gray">准用</span>
            <span v-else-if="scope.row.sbzt == '4'" style="color:orange">报废</span>
            <span v-else-if="scope.row.sbzt == '40'" style="color:orange">待维保</span>
            <span v-else-if="scope.row.sbzt == '41'" style="color:orange">停用(待检定)</span>
            <span v-else-if="scope.row.sbzt == '42'" style="color:orange">调拨</span>
            <span v-else-if="scope.row.sbzt == '43'" style="color:orange">停用(待校准)</span>
            <span v-else-if="scope.row.sbzt == '44'" style="color:orange">停用(待核查)</span>
            <span v-else-if="scope.row.sbzt == '45'" style="color:orange">降级使用</span>
          </template>
        </el-table-column>
      </el-table>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="tableData.length > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
          :total="total" style="float:right">
        </el-pagination>
      </el-col>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="transmit">选择</el-button>
        <el-button @click="guanbi">关闭</el-button>
      </span>
      <!-- 添加显示购物车按钮，如果复选框有选中让显示，否则不显示 -->
      <div style="position:fixed;top:61%;left:30%;height:50px;width: 50px;color: #4095E5;font-size: 20px;"
        @click="checkBoxdialog = true" v-if="checkBoxData.length > 0">
        <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
        <el-badge :value="checkBoxNumber">
          <img src="../../../static/img/selects.png" style="width:70%;height:70%;font-size: 40px;">
          <!-- <span class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></span> -->
        </el-badge>
      </div>
      <!-- 显示购物车列表 -->
      <el-dialog title="已选择设备" :visible.sync="checkBoxdialog" append-to-body :close-on-click-modal="false"
      :close-on-press-escape="false"> 
        <el-button type="primary" size="mini" @click="removeAllCheckbox"
          style="margin-top:-30px;float:left">清空内容</el-button>
        <el-table :data="checkBoxData" v-if="checkBoxNumber > 0" :header-cell-style="{ background: '#eff3f6' }"
          style="padding-top:5px">
          <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
          <el-table-column property="glbh" label="管理编号"></el-table-column>
          <el-table-column property="zcmc" label="资产名称"></el-table-column>
          <el-table-column property="zcbh" label="资产编号"></el-table-column>
          <el-table-column property="sbxh" label="设备型号"></el-table-column>
          <el-table-column label="操作" style="text-decoration: none;">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="removeThisData(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </el-dialog>
  </div>
</template> 
<script>
import {
  treeCompany,
  selectTaskDevice,
  getStatueByDevice

} from "../../api/api";
export default {
  name: "TaskDevice",
  props: [
    'transferValue',
    'personInfo',
    "zxdw"
  ],
  data() {
    return {
      formInline: {
        content: '',
        statue: '',
        companyCode: '',
      },
      props1: {
        label: 'companyName',
        value: 'companyCode',
        children: 'zcompany',
        expandTrigger: 'click',
        emitPath: false
      },
      disabled: "",
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      deviceVisible: false,
      tableData: [],
      deviceTable: [],
      options: [],
      outData: {},
      checkBoxdialog: false,
      checkBoxNumber: 0,
      checkBoxData: [],
      deviceStatuData: [{
        name: '可调拨',
        id: 0
      }, {
        name: '在用',
        id: 1
      }
        , {
        name: '全部设备',
        id: ''
      }],
      isSelect: false
    };
  },

  methods: {
    //查找设备状态   
    findAllType() {
      getStatueByDevice().then(datas => {
        let { status, message, data } = datas;
        var list = []
         if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "设备台账" && data[i].id != 3) {
              list.push({ name: data[i].statusName, id: data[i].id })
            }
          }
          this.deviceStatuData = list;
        }
      })
    },
    getRowKeys(row) {
      return row.id;
    },
    guanbi() {
      this.$refs.deviceTable.clearSelection();
      this.deviceVisible = false
    },
    //获取复选框选中数据
    changeCheckBoxValue(val) {
      this.checkBoxData = val
      this.checkBoxNumber = this.checkBoxData.length
    },
    //清空所有内容
    removeAllCheckbox() {
      this.checkBoxData = [];
      this.checkBoxNumber = this.checkBoxData.length
      this.$refs.deviceTable.clearSelection()//清除所有选中复选框
      this.checkBoxdialog = false
    },
    handleClose(done) {
      this.$refs.deviceTable.clearSelection();
      done();
    },
    //移除一条选中内容
    removeThisData(row) {
      let newCheckBoxData = []
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].id != row.id) {
          // debugger
          newCheckBoxData.push(this.checkBoxData[i])
        }
      }
      this.checkBoxData = newCheckBoxData
      if (this.checkBoxData.length > 0) {
        this.$refs.deviceTable.store.states.selection.map((item, index) => {
          if (item.id === row.id) {
            this.$refs.deviceTable.store.states.selection.splice(index, 1)
          }
        })
      } else {
        this.$refs.deviceTable.clearSelection()//清除所有选中复选框
        this.checkBoxdialog = false
      }
      this.checkBoxNumber = this.checkBoxData.length
    },
    openWindow() {
      if (this.zxdw == null || this.zxdw == "") {
        this.$message.warning("请选择执行单位")
      } else {
        this.deviceVisible = true;
        // var user = JSON.parse(localStorage.getItem("user"))
        // if (user.userRole == 1 || (user.fjqx != null && (user.fjqx.indexOf("3") != -1 || user.fjqx.indexOf("4") != -1))) {
        //   // this.formInline.companyCode=""
        // } else {
        //   this.formInline.companyCode = user.companyCode;
        // }
        this.findAll()
      }
    },
    transmit() {
      let currentSelect = this.$refs.deviceTable.selection;
      if (currentSelect.length > 0) {
        this.outData = currentSelect;
        this.transferValue(this.outData);
        this.deviceVisible = false;
      } else {
        this.$message.error("请选择一条信息"); // .....失败信息
      }
    },
    selectCompany() {
      treeCompany().then(datas => {
        let { status, message, data } = datas;
         if (status == 200) {
          this.options = this.getTreeData1(data);
        }
      });
    },
    getTreeData1(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData1(data[i].zcompany);
        }
      }
      return data;
    },
    //查找所有调拨信息
    findAll() {
      var user = JSON.parse(localStorage.getItem("user"))

      let map = {
        companyCode: this.zxdw,
        content: this.formInline.content,
        state: this.formInline.statue,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        userId:user.userId
      };
      selectTaskDevice(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
         if (status == 200) {
          this.tableData = data.list;
          this.total = data.total;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.findAll();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.findAll();
    },
  },
  created() {
    this.selectCompany();
    this.$set(this.formInline, 'statue', this.personInfo)
    // this.findAllType();
  }
};
</script>
<style scoped></style>
    


// WEBPACK FOOTER //
// src/components/common/TaskDevice.vue